import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Instagram, Mail, Phone } from 'lucide-react';
import { mockData } from '../mock';

const Footer = () => {
  const navigate = useNavigate();

  const handleNavClick = (path) => {
    navigate(path);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src="/images/LogoWhiteNew.jpeg"
                alt="Medics on Mission Logo"
                className="h-10 w-auto object-contain"
              />
              <h3 className="text-lg font-bold" style={{ fontFamily: 'Poppins, sans-serif' }}>
                Medics on Mission
              </h3>
            </div>
            <p className="text-gray-400 mb-4 max-w-md" style={{ fontFamily: 'Open Sans, sans-serif' }}>
              Providing medical outreach, free clinics, and supplies to underserved communities worldwide.
            </p>
            <p className="text-sm text-gray-500" style={{ fontFamily: 'Open Sans, sans-serif' }}>
              100% of donations go directly to missions.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
              Quick Links
            </h4>
            <ul className="space-y-2">
              <li>
                <button onClick={() => handleNavClick('/about')} className="text-gray-400 hover:text-white transition-colors">
                  About Us
                </button>
              </li>
              <li>
                <button onClick={() => handleNavClick('/projects')} className="text-gray-400 hover:text-white transition-colors">
                  Our Projects
                </button>
              </li>
              <li>
                <button onClick={() => handleNavClick('/get-involved')} className="text-gray-400 hover:text-white transition-colors">
                  Get Involved
                </button>
              </li>
              <li>
                <button onClick={() => handleNavClick('/donate')} className="text-gray-400 hover:text-white transition-colors">
                  Donate
                </button>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
              Contact
            </h4>
            <ul className="space-y-3">
              <li>
                <a
                  href={`mailto:${mockData.contact.email}`}
                  className="flex items-center space-x-2 text-gray-400 hover:text-white transition-colors"
                >
                  <Mail className="h-4 w-4" />
                  <span className="text-sm">{mockData.contact.email}</span>
                </a>
              </li>
              <li>
                <a
                  href={mockData.contact.instagramUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center space-x-2 text-gray-400 hover:text-white transition-colors"
                >
                  <Instagram className="h-4 w-4" />
                  <span className="text-sm">{mockData.contact.instagram}</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center">
          <p className="text-gray-500 text-sm" style={{ fontFamily: 'Open Sans, sans-serif' }}>
            © {new Date().getFullYear()} Medics on Mission. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;